import LocalOfferOutlined from "@mui/icons-material/LocalOfferOutlined";
import { Popover } from "@mui/material";
import { type MouseEvent,useState } from "react";

import CoAppIconActionButton from "../global/components/inputs/CoAppIconActionButton";
import TagPickerPanel from "./TagPickerPanel";

// ─────────────────────────────────────────────────────────────────────────────
// TagManagement — header "Manage Tags" entry point. The popover content is
// the shared TagPickerPanel in `manage` mode (no row to add the tag to —
// just create / rename / delete).
// ─────────────────────────────────────────────────────────────────────────────

interface TagManagementProps {
	initRuleLibrary: () => void;
}

export default function TagManagement({ initRuleLibrary }: TagManagementProps) {
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
	const open = Boolean(anchorEl);

	const handleOpenClick = (event: MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleCloseClick = () => {
		setAnchorEl(null);
	};

	return (
		<div>
			<CoAppIconActionButton
				icon={<LocalOfferOutlined sx={{ marginRight: "5px", color: "#FFFFFF", fontSize: "18px" }} />}
				text="Manage Tags"
				onClick={handleOpenClick}
			/>
			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleCloseClick}
				anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
				transformOrigin={{ vertical: "top", horizontal: "right" }}
				slotProps={{
					paper: {
						sx: {
							mt: 0.75,
							borderRadius: 2.5,
							border: "1px solid rgba(13, 31, 48, 0.06)",
							boxShadow: "0 12px 30px rgba(13, 31, 48, 0.14), 0 2px 8px rgba(13, 31, 48, 0.06)",
							overflow: "hidden"
						}
					}
				}}
			>
				<TagPickerPanel mode="manage" onTagsChanged={initRuleLibrary} />
			</Popover>
		</div>
	);
}
